import { Box } from "@mui/material"
import { AppFormGrid, AppFormSection } from "@components"
import React from "react"
import {
	ReportDateRangeExecutionField,
	ReportEmailField,
	ReportFrequencyDaysField,
	ReportFrequencyHoursField,
	ReportLaunchRepricingSwitch,
	ReportManualExecutionSwitch
} from "Pages/ReportsAlerts/Reports/@components/FormDrawer/Fields"
import { userData } from "@signals"

export default function ReportFormDrawerFrequencySection() {
	const hasRepricing = !!userData.value?.featuresV2?.ds_repricing

	return <AppFormSection icon="circle-play" title="Frequency & Notification">
		<AppFormGrid>
			<Box sx={{ gridColumn: '1 / -1' }} data-tour-id="tour-email">
				<ReportEmailField/>
			</Box>
			<Box sx={{ gridColumn: 'span 5' }} data-tour-id="tour-exec-frequency">
				<ReportFrequencyHoursField/>
			</Box>
			<Box sx={{ gridColumn: 'span 5' }} data-tour-id="tour-frequencies">
				<ReportFrequencyDaysField/>
			</Box>
			<Box sx={{ gridColumn: '1 / -1', display: 'flex', alignItems: 'center', columnGap: 3.5, rowGap: 1, flexWrap: 'wrap' }}>
				<ReportManualExecutionSwitch/>
				{hasRepricing && <ReportLaunchRepricingSwitch/>}
			</Box>
			<Box sx={{ gridColumn: '1 / -1' }}>
				<ReportDateRangeExecutionField/>
			</Box>
		</AppFormGrid>
	</AppFormSection>
}
